import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onBeforeMount } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import { salesClueChangeInvalid } from '@/api/overseasSales/clueManage'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { SalesClueListItem, InvalidClueParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'BecomeInvalid' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const formRef = ref<FormInstance>()
const initForm = { clueIdList: [], invalidId: -9, remark: '' }
const dataForm = ref<InvalidClueParams>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  clueIdList: [{ required: true, message: t('common.pleaseSelect') }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }]
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_invalid_reason']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const init = (data: SalesClueListItem[]) => {
  dataForm.value.clueIdList = data.map((item: SalesClueListItem) => item.clueId)
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    salesClueChangeInvalid(params)
      .then(() => {
        DcMessage.success(t('tips.AbHrgv'))
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleBecomeInvalidCancel = () => {
  formRef.value?.resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: _unref(t)('clue.nvalidModalTitle'),
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleBecomeInvalidOk,
    onCancel: handleBecomeInvalidCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: dataForm.value,
        ref_key: "formRef",
        ref: formRef,
        rules: formRules,
        "wrapper-col": { span: 24 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "clueIdList",
            label: _unref(t)('clue.customerName')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.value.clueIdList,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.clueIdList) = $event)),
                options: selectedData.value,
                fieldNames: { label: 'customerName', value: 'clueId' },
                mode: "multiple",
                "max-tag-count": 100,
                disabled: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_dc_form_item, {
            name: "invalidId",
            label: _unref(t)('clue.invalidReason'),
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.value.invalidId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.invalidId) = $event)),
                options: paramCodeData.value.ofbu_invalid_reason,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_a_form_item, {
            name: "remark",
            label: _unref(t)('common.remark')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.value.remark,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.remark) = $event)),
                maxlength: 2000
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirm-loading"]))
}
}

})